import React, { useRef } from 'react';

import { Button, Typography } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

const ErrorDialog = ({ open, onClose, title, message }) => {
  const text = useRef();

  if (open) {
    text.current = Array.isArray(message) ? message : [message];
  }

  return (
    <Dialog open={open}>
      <DialogTitle>{title || 'An error has occurred'}</DialogTitle>

      <DialogContent>
        {(text.current || []).map((it, index) => (
          <Typography key={index} variant="body1" align="center">
            {it}
          </Typography>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
